import type { IntervalFilterPreset } from 'components/Common/Filters/IntervalPresets'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import i18n from 'utils/i18n'
import type { AdminVerifiedRelationsFilterName } from 'utils/filters/admin'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  RADIO_LIST,
  INTERVAL,
  SEARCH_USERS,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationVerifiedRelationsFiltersCollection = () => [
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineCountryFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineCountryFilter satisfies AdminVerifiedRelationsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.productCountryFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.isModelDisagreeFilter),
    filterName:
      ADMIN_FILTERS_NAME.isModelDisagreeFilter satisfies AdminVerifiedRelationsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.isModelDisagreeFilter,
  },

  {
    type: filterTypes[INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.conflictsFilter),
    filterName:
      ADMIN_FILTERS_NAME.alcoholLevelFilter satisfies AdminVerifiedRelationsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.conflictMinConfidenceFilter,
    presets: [
      {
        min: 0,
        max: 0,
        label: i18n.t('filters.interval.content', { f: 0, t: 0 }),
      },
      {
        min: -9998,
        max: 0,
        label: i18n.t('filters.interval.all', { f: -9998, t: 0 }),
      },
    ] as IntervalFilterPreset[],
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.relationTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.relationTypeFilter satisfies AdminVerifiedRelationsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.relationTypeFilter,
  },

  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.verificationUserFilter),
    filterName:
      ADMIN_FILTERS_NAME.authorUserFilter satisfies AdminVerifiedRelationsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.authorUserFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.verificatedAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.verificatedAtFilter satisfies AdminVerifiedRelationsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.verificationUpdatedAtFilter,
  },
]

export const adminVerifiedRelationsFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationVerifiedRelationsFiltersCollection,
  pathToStore: [],
  filtersDataPath: ['admin', 'mentions', 'mentionVerificationFilters'],
  showResultsTextKey: 'filters.button.apply',
  showPresets: false,
}
